/**
 *
 * Asynchronously loads the component for LoginPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UpdateProfilePage = lazyLoad(
  () => import('./index'),
  module => module.UpdateProfilePage,
);
